const generalReducer = (state = {}, action) => {
  switch (action.type) {
    case 'set-profile': {
      return { ...state, profile: action.profile }
    }
    case 'clear-profile': {
      const { profile, ...newState } = state
      return newState
    }
    default:
      return state
  }
}

export default generalReducer